<template>
  <section class="email-otp-verification" aria-labelledby="email-otp-heading">
    <div class="verification-icon mb-4" aria-hidden="true">
      <v-icon color="primary" size="32">mdi-email-lock-outline</v-icon>
    </div>
    <h3 id="email-otp-heading" class="text-h6 mb-2">Verify your email address</h3>
    <p class="grey--text text--darken-1 mb-6">
      Enter the one-time password sent to <strong class="basic--text">{{ email }}</strong>.
    </p>

    <v-form v-model="valid" @submit.prevent="verify">
      <x-text-field
        v-model.trim="otp"
        outlined
        dense
        autofocus
        autocomplete="one-time-code"
        label="One-time password"
        placeholder="Enter OTP"
        :rules="otpRules"
        :disabled="loading"
      ></x-text-field>

      <x-button
        type="submit"
        color="primary"
        width="100%"
        :disabled="!valid || loading"
        :loading="loading"
      >
        Verify and register
      </x-button>
    </v-form>

    <div class="d-flex flex-wrap justify-center align-center otp-actions mt-4">
      <x-button text color="primary" :disabled="loading" @click="$emit('resend')">
        Resend OTP
      </x-button>
      <x-button text color="grey darken-1" :disabled="loading" @click="$emit('back')">
        Change email
      </x-button>
    </div>
  </section>
</template>

<script>
import XButton from "@ui/widgets/XButton.vue";
import XTextField from "@ui/widgets/XTextField.vue";

export default {
  name: "EmailOtpVerification",
  components: { XButton, XTextField },
  props: {
    email: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    otp: "",
    valid: false,
    otpRules: [value => !!String(value || "").trim() || "OTP is required"],
  }),
  methods: {
    verify() {
      if (!this.valid || this.loading) return;
      this.$emit("verify", this.otp.trim());
    },
  },
};
</script>

<style scoped>
.email-otp-verification {
  max-width: 460px;
  margin: 24px auto 8px;
  text-align: center;
}

.verification-icon {
  align-items: center;
  background: rgba(25, 118, 210, 0.08);
  border-radius: 50%;
  display: inline-flex;
  height: 64px;
  justify-content: center;
  width: 64px;
}

.otp-actions {
  gap: 4px;
}
</style>
